import React from "react";
import GHGActionsBar from "./GHGActionsBar";
import GHGList from "./GHGList";

const GHG = (props) => {
    const { farm, budget, online } = props;
    return (
        <React.Fragment>
            <GHGActionsBar farm={farm} budget={budget} online={online} />
            <GHGList farm={farm} budget={budget} />
        </React.Fragment>
    );
};

export default GHG;
